import filesize from 'filesize';
import FileItem from '@/file/file-item';
import scaffoldBlobValidator from './scaffold-blob-validator';
import config from '@/config';

export default class ScaffoldExtractor {
  static validateConfigFiles(files) {
    const [configFile] = files.filter((file) =>
      file.path.endsWith('scaffoldhub/config.yml'),
    );
    let sampleFile = null;

    try {
      [sampleFile] = files.filter((file) =>
        file.path.endsWith('scaffoldhub/sample.json'),
      );
    } catch (err) {
      sampleFile = null;
    }

    return scaffoldBlobValidator
      .validateBlobFiles(configFile, sampleFile)
      .then(() => files);
  }

  static isToIgnore(path, isDir, unusedPrefix, ignoreFile) {
    if (unusedPrefix && !path.startsWith(unusedPrefix)) {
      return true;
    }

    if (isDir) {
      return true;
    }

    if (!ignoreFile) {
      return false;
    }

    return ignoreFile.isToIgnore(
      this.removeUnusedPrefix(path, unusedPrefix),
    );
  }

  static removeUnusedPrefix(path, unusedPrefix) {
    let pathWithoutPrefix = path;
    if (unusedPrefix) {
      pathWithoutPrefix = path.replace(
        `${unusedPrefix}/`,
        '',
      );
    }
    return pathWithoutPrefix;
  }

  static unusedPrefix(paths) {
    return Promise.resolve().then(() => {
      const configFile = this.configFile(paths);
      const folders = configFile.foldersArray();
      folders.pop();
      return folders.join('/');
    });
  }

  static configFile(paths) {
    let file = null;
    paths.forEach((path) => {
      if (path.endsWith('scaffoldhub/config.yml')) {
        file = new FileItem(path);
      }
    });
    if (file == null) {
      throw new Error(
        "File 'scaffoldhub/confg.yml' not found!",
      );
    }
    return file;
  }

  static validateSize(files) {
    return Promise.resolve().then(() => {
      const limit = config.SCAFFOLD_SIZE_LIMIT_IN_BYTES;
      const codeLimit =
        config.SCAFFOLD_CODE_SIZE_LIMIT_IN_BYTES;

      let totalCode = 0;
      files
        .filter((f) => !f.binary)
        .forEach((file) => {
          totalCode += file.blob.size;
        });
      if (totalCode > codeLimit) {
        throw new Error(
          `Scaffold code files (non binary) limit is ${filesize(
            codeLimit,
          )}!`,
        );
      }

      let total = 0;
      files.forEach((file) => {
        total += file.blob.size;
      });
      if (total > limit) {
        throw new Error(
          `Scaffold limit is ${filesize(limit)}!`,
        );
      }
    });
  }
}
